import { h, render } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import clsx from 'clsx';
import ArrowLeft from '../utils/icon/long-arrow-left.svg';
import ArrowRight from '../utils/icon/long-arrow-right.svg';
import ProductCard from '../product-card/product-card';
import { getCollectionProducts } from '../utils/storefront/get-products';
import { waitForElm } from '../utils/helpers';

export default (element, data) => {
  const VProductsHero = ({
    encodedCollectionId,
    sectionId,
    stackOnMobile,
  }) => {
    const [products, setProducts] = useState([]);

    useEffect(() => {
      const getProducts = async () => {
        const collectionProducts = await getCollectionProducts(
          encodedCollectionId,
          12,
        );
        setProducts(
          collectionProducts?.data?.node?.products?.edges?.slice(0, 8) || []
        );
      };
      getProducts();
    }, []);

    const initReviewWidget = () => {
      waitForElm('.yotpo.bottomLine').then(() => {
        if (window.yotpo?.initWidgets) {

          if (window.yotpo.initialized) {
            window.yotpo.refreshWidgets()
          } else window.yotpo.initWidgets();

          let attempts = 0;
          const interval = setInterval(() => {
            if (
              document.querySelectorAll('.yotpo-bottomline a').length > 0 ||
              attempts > 1000
            ) {
              clearInterval(interval);
              window.yotpo.widgets.map((widget) => {
                const widgetNodeStarsText = widget.element.querySelector(
                  '.yotpo-bottomline a',
                );
                if (widgetNodeStarsText) {
                  widgetNodeStarsText.remove();
                }
                return '';
              });
            }
            attempts += 1;
          }, 100);
        }
      });
    }

    const baseArrowClass = ' !static !bg-transparent !m-0 !text-black after:!content-[none] navigation-arrow'
    const arrowClass =  '!border-0 !w-[33px] !h-[24px] disabled:!opacity-0 pointer-events-auto'

    return (
      <div
        id={`Recommendations--${sectionId}`}
        className="pt-5 laptop:pt-[30px] laptop:pb-5 relative"
      >
        {
          stackOnMobile && (
            <div className='laptop:hidden px-[29px] grid grid-cols-2 gap-1.5'>
              {products.map((product, index) => (
                <ProductCard
                  key={`stacked-product-card-${index}`}
                  customClass="h-full text-black"
                  currentProduct={product.node}
                />
              ))}
            </div>
          )
        }
        <div className={clsx('[&_.yotpo-stars+a]:hidden', stackOnMobile && 'hidden laptop:block')}>
          <div
            className='hidden laptop:flex justify-between absolute gap-2.5 inset-x-[50px] top-1/2 -translate-y-1/2 pointer-events-none z-[5]'
          >
            <button className={clsx('swiper-button-prev', baseArrowClass, arrowClass)}>
              <ArrowLeft />
            </button>
            <button className={clsx('swiper-button-next', baseArrowClass, arrowClass)}>
              <ArrowRight />
            </button>
          </div>
          <Swiper
            slidesPerView={2.2}
            spaceBetween={10}
            modules={[Navigation]}
            onAfterInit={initReviewWidget}
            navigation={{
              nextEl: `#Recommendations--${sectionId} .swiper-button-next`,
              prevEl: `#Recommendations--${sectionId} .swiper-button-prev`,
            }}
            pagination={{
                el: `#Recommendations--${sectionId} .custom-pagination`,
                clickable: true,
                type: 'bullets',
                bulletClass: 'bullet size-2 bg-white opacity-40',
                bulletActiveClass: 'bullet-active before:hidden after:hidden !opacity-100',
              }}
            className='!px-5 laptop:!px-10 !pb-5'
            breakpoints={{
              1024: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
            }}
          >
            {products.map((product, index) => (
              <SwiperSlide className="!h-auto" key={`product-card-${index}`}>
                <ProductCard
                  customClass="h-full text-black"
                  currentProduct={product.node}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="custom-pagination laptop:hidden z-[1] !w-auto flex items-center justify-center gap-3.5 relative" />
        </div>
      </div>
    );
  };
  const init = () => {
    render(<VProductsHero {...data} />, element);
  };

  init();
};
